exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#top-nav-bar {\n  overflow: hidden;\n  background-color: black;\n  width: 100%;\n\n}\n\n@media screen and (max-width: 1100px) {\n  #free-ship {\n    display: none;\n  }\n  #top-nav-bar {\n    display: inline-flexblock;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    text-align: center;\n  }\n}\n\n#free-ship {\n  padding-right: 300px;\n}\n\n.top-navbar {\n  margin-top: 100px;\n  display: inline;\n\n}\n\na {\n  text-decoration: none;\n  color: white;\n  padding-right: 50px;\n  font-size: 15px;\n  font-family: serif;\n\n}\n\nul {\n\n  text-align: right\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/juliusbade/Desktop/UnderArmour-Rebuild/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main